import { mapGetters } from "vuex";
export default {
  data() {
    return {
      testingVoiceMsg: '',
      testingVoiceInfo: {}
    }
  },
  computed: {
    ...mapGetters([
      'UserLevelInfo'
    ]),
  },
  methods: {
    async fetchTestVoiceCount () {
      if (this.UserLevelInfo.levelName === 'basic') {
        const {data} = await this.$http.get('/api/user/audioAI/getTimes');
        const {times, useTimes} = data.data;
        const remain = Math.max(0, times - useTimes);
        this.testingVoiceMsg = `(${remain}/${times})`;
        if (remain > 100) {
          this.testingVoiceMsg = '';
        }
        this.testingVoiceInfo = {total: times, remain};
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/testVoice.js